<template>
  <b-container fluid id="app-container">
    <Main/>
  </b-container>
</template>

<script>
	import Main from './components/Main.vue'

	export default {
		name: 'app',

		components: {
			Main
		}

	}
</script>

<style lang="scss">
  @import './scss/custom';

  body {
    background-color: $body-bg;
    height: 100%;
  }
</style>

<style scoped>
  html{
    font-size: 16px;
    height: 100%;
  }
  /*body {*/
    /*height: 100%;*/
  /*}*/
  #app-container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0;
    padding-top: 0;
    padding: 0;
  }
  /**/
  /*#app-container {*/
    /*padding-right: 0;*/
    /*padding-left: 0;*/
  /*}*/

  /*!* xs < 768 *!*/
  /*@media screen and (max-width: 767px) {*/
    /*body {*/
      /*font-size: 0.9rem;*/
    /*}*/
  /*}*/

  /*!* sm *!*/
  /*@media screen and (min-width: 768px) {*/
    /*body {*/
      /*font-size: 1rem;*/
    /*}*/
  /*}*/

  /*!* md *!*/
  /*@media screen and (min-width: 992px) {*/
    /*body {*/
      /*font-size: 1.2rem;*/
    /*}*/
  /*}*/

  /*!* lg *!*/
  /*@media screen and (min-width: 1200px) {*/
    /*body {*/
      /*font-size: 1.3rem;*/
    /*}*/
  /*}*/

</style>
